import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    inject,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { MessageDialogData } from './message-dialog-data';
import { FLOORI_DIALOG_DATA, FlooriDialogModule } from '../floori-dialog';
import { TranslationsModule } from '../../modules';
import { FlooriIconComponent } from '../floori-icon/floori-icon.component';

@Component({
    selector: 'floori-message-dialog',
    standalone: true,
    imports: [
        FlooriDialogModule,
        TranslationsModule,
        FlooriIconComponent,
    ],
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class MessageDialogComponent implements OnInit, OnDestroy {
    readonly data: MessageDialogData = inject<MessageDialogData>(FLOORI_DIALOG_DATA);
    private readonly dialogRef = inject(DialogRef);
    private autoCloseTimer: any;

    @HostBinding('class.floori-message-dialog') hostClass = true;

    ngOnInit(): void {
        this.autoCloseTimer = setTimeout(() => {
            this.dialogRef.close();
        }, 15000);
    }

    ngOnDestroy(): void {
        if (this.autoCloseTimer) {
            clearTimeout(this.autoCloseTimer);
        }
    }

    trackBy(index: number, line: string): string {
        return line;
    }
}
